export default __webpack_public_path__ + "static/media/rudresh.62c67d53.jpg";